import { ActionReducerMap } from '@ngrx/store';

import * as fromAuditTrailReducers from './applet-audit-trail.reducers';
import { AuditTrailStates } from '../states';

export const auditTrailReducers: ActionReducerMap<AuditTrailStates> = {
    auditTrail: fromAuditTrailReducers.auditTrailReducer
};